export default "__VITE_ASSET__BNjTXdRO__"